// src/auth/PrivateRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';


export default function PrivateRoute({ children }) {
  const { status, user } = useAuth();
  if (status === 'loading') return <div style={{ padding: 24 }}>Checking session…</div>;
  if (status !== 'authed' || !user) return <Navigate to="/login" replace />;
  if (user.isAdmin || user.role === "ADMIN") return children;

  const sub = user.subscription || {};
  const expired = !(sub.status === 'ACTIVE' && sub.endsAt && new Date(sub.endsAt) > new Date());
  if (expired) return <Navigate to="/subscribe" replace />;
  return children;
}
